module.exports = __webpack_public_path__ + "static/media/arrow-forward.24eb0872.svg";